import { Component, Input, OnInit} from '@angular/core';
import { Producto } from '../../../_models/producto';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { AgrupacionService } from '../../../_services/agrupacion.service';
import { Agrupacion } from '../../../_models/agrupacion';
import { EstructuraFisicaService } from '../../../_services/estructura-fisica.service';
import { EstructuraFisica } from '../../../_models/estructura-fisica';
import { ProductoRestriccionOficina } from '../../../_models/producto-restriccion-oficina';
import { ProductoRestriccionOficinaService } from '../../../_services/producto-restriccion-oficina.service';

@Component({
  selector: 'app-producto-restriccion',
  templateUrl: 'producto-restriccion.component.html'
})

export class ProductoRestriccionComponent implements OnInit {

  @Input() producto: Producto;

  // Todas las estructuras físicas por agrupacion
  estructuraFiAgrupacion: EstructuraFisica[] = [];

  // Producto restriccion oficina
  listaTodosProductosRestriccionOficina: ProductoRestriccionOficina[] = [];
  // Arreglo que almacena la lista de restricciones iniciales para compararla a la hora de enviar
  listaTodosProductosRestriccionOficinaOriginal: ProductoRestriccionOficina[] = [];

  listaProductoRestriccionOficina: ProductoRestriccionOficina[] = [];
  productoRestriccionOficina: ProductoRestriccionOficina;
  listaProductosRestriccionOficinaRestringidos: ProductoRestriccionOficina[] = [];

  // Almacena la restricción seleccionada en los p-list
  productoRestriccionOficinaRestringido: ProductoRestriccionOficina;

  agrupacionSeleccionada: string;
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  tab = 'OFI';

  // agrupacionSeleccionada: Agrupacion;
  lisOficinas: SelectItem[] = [];
  lisAgrupaciones: SelectItem[] = [];

  constructor(
    private navServicio: NavService,
    private location: Location,
    private estrucurasFisicaServicio: EstructuraFisicaService,
    private productoRestriccionOficinaServicio: ProductoRestriccionOficinaService,
    private fb: FormBuilder,
    private agrupacionServicio: AgrupacionService,
    private conServicio: ConfirmationService) {
  }

  ngOnInit(): void {
  this.cargarInformacionInicial();
  }

  cargarInformacionInicial() {
    forkJoin(
      this.agrupacionServicio.getAll(),
      this.productoRestriccionOficinaServicio.listadoPorProducto(this.producto.idProducto))
      .subscribe(([lisAgru, lisRestricProducto]) => {
        // llenado lista agrupaciones
        lisAgru.map((s: Agrupacion) => {
          this.lisAgrupaciones.push({label: s.agrupacion, value: s.idAgrupacion});
        });
        this.listaTodosProductosRestriccionOficina = lisRestricProducto;
        this.listaTodosProductosRestriccionOficinaOriginal = this.listaTodosProductosRestriccionOficina.map(obj => ({...obj}));
        this.filtrarProductosRestriccionOficina();
        this.carInformacionInicial = false;
      });
  }

  get f() {
    return this.formulario.controls;
  }
  regresar() {
    this.location.back();
  }

  onSubmit() {
    if (JSON.stringify(this.listaTodosProductosRestriccionOficina) === JSON.stringify(this.listaTodosProductosRestriccionOficinaOriginal)) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_OFINORELACIONADA' )
      } );
    } else {
      this.submitted = true;
      this.guardando = true;
      this.productoRestriccionOficinaServicio.bulk(this.listaTodosProductosRestriccionOficina).subscribe(
        res => {
          this.cargarInformacionInicial();
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage( 1 );
        },
        error => {
          this.navServicio.setMesage( 3 );
        }
      );
    }
  }

  // funcion para restringir un producto por una sola oficina
  restringir( restriccion: ProductoRestriccionOficina , accion: boolean) {
    if (restriccion === undefined) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_OFINOSELECCIONADA' )
      } );
    } else {
      const restric = this.listaTodosProductosRestriccionOficina.find(
        x => x.idProducto === restriccion.idProducto && x.idEstructuraFisica === restriccion.idEstructuraFisica);
    // Agregamos la restriccion
    if (accion) {
      if (restric === undefined) {
        restriccion.indicadorHabilitado = true;
        this.listaTodosProductosRestriccionOficina.push(restriccion);
        this.filtrarProductosRestriccionOficina();
      } else {
        // Se actualiza la restriccion
        let index = this.listaTodosProductosRestriccionOficina.indexOf(restric);
        restric.indicadorHabilitado = true;
        this.listaTodosProductosRestriccionOficina[index] = restric;
        this.filtrarProductosRestriccionOficina();
      }
      // reinicio del apuntador del p-list
      this.productoRestriccionOficina = undefined;
    } else {
      if (restric === undefined) {

      } else {
        // se actualiza la restriccion
        let index = this.listaTodosProductosRestriccionOficina.indexOf(restriccion);

        // Se elimina el productoRestriccion parcial que se había agregado al bulk
        if ( restric.idProductoRestriccionOficina === null || restric.idProductoRestriccionOficina === undefined) {
          this.listaTodosProductosRestriccionOficina.splice(index, 1);
        } else {
          // Se inhabilita el productoRestriccion existente
          restriccion.indicadorHabilitado = false;
          this.listaTodosProductosRestriccionOficina[index] = restriccion;
        }
        this.filtrarProductosRestriccionOficina();
        this.productoRestriccionOficinaRestringido = undefined;
      }
    }
  }
  }

  // funcion para restringir un producto por todas las oficinas
  restringirTodos(accion: boolean) {
    if ( accion ) {
      for (let restric of this.listaProductoRestriccionOficina ) {
        let restriccionReal = this.listaTodosProductosRestriccionOficina.find(
          x => x.idEstructuraFisica === restric.idEstructuraFisica && x.idProducto === restric.idProducto);
        if ( restriccionReal === undefined) {
          restric.indicadorHabilitado = true;
          this.listaTodosProductosRestriccionOficina.push(restric);
        } else {
          let index = this.listaTodosProductosRestriccionOficina.indexOf(restric);
          restric.indicadorHabilitado = true;
          this.listaTodosProductosRestriccionOficina[index] = restric;
        }
      }
      this.filtrarProductosRestriccionOficina();
      this.productoRestriccionOficina = undefined;
    } else {
      // Se inhabilitan todos los productosRestricciones
      for (let restric of this.listaTodosProductosRestriccionOficina) {
        // Se inhabilita el productoRestriccion existente
        restric.indicadorHabilitado = false;
      }
      // Se eliminan los productosRestriccionOficina parciales
      this.listaTodosProductosRestriccionOficina = this.listaTodosProductosRestriccionOficina.filter(
        x => (x.indicadorHabilitado === true) || (x.indicadorHabilitado === false && x.idProductoRestriccionOficina !== null));
      // Se actualiza las listas de productoRestriccion
      this.filtrarProductosRestriccionOficina();
      this.productoRestriccionOficinaRestringido = undefined;
    }
  }
  regresarFormulario() {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        key: 'producto-restriccion',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
  }

  cambiarAgrupacion(idZonal: string) {
    this.agrupacionSeleccionada = idZonal;
    this.estrucurasFisicaServicio.obtenerPorAgrupacion(this.agrupacionSeleccionada).subscribe(
       estrucFis  => {
        // Llenado lista estructurasFísicas
        this.estructuraFiAgrupacion = estrucFis;
        this.filtrarProductosRestriccionOficina();
      }
    );
  }

  filtrarProductosRestriccionOficina() {
    this.listaProductosRestriccionOficinaRestringidos = [];
    this.listaProductoRestriccionOficina = [];
    // Llenado productos restricciones oficinas
    for (let restric of this.listaTodosProductosRestriccionOficina) {
      if ( restric.indicadorHabilitado === true) {
        this.listaProductosRestriccionOficinaRestringidos.push(restric);
      }
    }
    for (let estructuraFi of this.estructuraFiAgrupacion) {
      let restriccion = this.listaTodosProductosRestriccionOficina.find(
        x => x.idEstructuraFisica === estructuraFi.idEstructuraFisica);
      if ( restriccion === undefined) {
        // Se crea el nuevo ProductoRestriccionOficina parcial
        const nuevaRestricParcial = {} as ProductoRestriccionOficina;
        nuevaRestricParcial.idProductoRestriccionOficina = null;
        nuevaRestricParcial.indicadorHabilitado = false;
        nuevaRestricParcial.idEstructuraFisica = estructuraFi.idEstructuraFisica;
        nuevaRestricParcial.idProducto = this.producto.idProducto;
        nuevaRestricParcial.nombreOficina = estructuraFi.estructuraFisica;
        this.listaProductoRestriccionOficina.push(nuevaRestricParcial);
      } else {
        if ( restriccion.indicadorHabilitado === false ) {
          this.listaProductoRestriccionOficina.push(restriccion);
        }
      }
    }
  }
}
